import { Component, OnInit, Inject } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiText } from '../../api-client-module';
import { Language } from '../../firestore-models/language';
import { TranslateService } from '@ngx-translate/core';

export interface MultiGeneralTextDialogData {
  autoTrans: boolean;
  texts?: ApiText[];
}

@Component({
  selector: 'app-multi-general-text-dialog',
  templateUrl: './multi-general-text-dialog.component.html',
  styleUrls: ['./multi-general-text-dialog.component.css'],
  standalone: false,
})
export class MultiGeneralTextDialogComponent implements OnInit {

  isAcquired: boolean = false;
  //汎用テキスト×言語数
  texts: ApiText[] = [];
  textsFormGroup!: FormGroup;
  textsArrayControl!: FormArray;

  //languagesコレクション
  private languagesCollection!: AngularFirestoreCollection<Language>;
  languagesObservable!: Observable<Language[]>;
  languagesSubscribe!: Subscription;

  languages: Array<Language> = [];

  currentLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiGeneralTextDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiGeneralTextDialogData,
    private formBuilder: UntypedFormBuilder,
    private angularFirestore: AngularFirestore,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.isAcquired = false;
    // NOTE: 日本語が先頭になるよう調整
    const langJa: Language = {
      id: 'ja',
      lang_code: 'ja',
      lang_name: '日本語',
      lang_name_en: '',
      lang_file: '',
      display_name: '',
      trans_lang_code: '',
      tts_lang_code: '',
      tts_voice_codes: null as any,
      enabled: true,
      created: null as any,
      updated: null as any
    }
    this.languages.push(langJa);
    this.languagesCollection = this.angularFirestore.collection<Language>(
      'languages', ref => ref.where('lang_code', '!=', 'ja'));
    this.languagesObservable = this.languagesCollection.valueChanges({ idField: 'id' });
    this.languagesSubscribe = this.languagesObservable.subscribe(languages => {
      for (const language of languages) {
        this.languages.push(language);
      }
      this.isAcquired = true;

      this.texts = this.data.texts!;
      if (!this.texts) {
        this.texts = [];
      }
      this.createForm();
      this.textsArrayControl = this.textsFormGroup.get('texts') as FormArray;
    });
    this.currentLang = this.translate.currentLang;
  }

  //テキストフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let isAutoAllTrans: boolean = this.texts.length > 0 ? true : false;
    for (const language of this.languages) {
      let auto_trans = false;
      let text = '';
      for (const value of this.texts) {
        if (language.lang_code === value.lang_code) {
          if (!value.auto_trans && language.lang_code !== 'ja') {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          text = value.text;
          break
        }
      }
      if (language.lang_code === 'ja') {
        // NOTE: 日本語だけ必須
        arrayControl.push(this.formBuilder.group(
          {
            autoTrans: [auto_trans],
            text: [text, [Validators.required]],
          }
        ));
      } else {
        arrayControl.push(this.formBuilder.group(
          {
            autoTrans: [auto_trans],
            text: [text],
          }
        ));
      }
    }
    this.textsFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        texts: arrayControl
      }
    );
  }

  //更新ボタン
  addTexts(): void {
    if (this.textsFormGroup.valid) {
      let texts = [];
      for (const index in this.languages) {
        texts.push(
          {
            auto_trans: this.textsArrayControl.controls[index].get('autoTrans')!.value,
            lang_code: this.languages[index].lang_code,
            text: this.textsArrayControl.controls[index].get('text')!.value
          }
        )
      }
      this.texts = texts;
      let res = {
        texts: this.texts
      }
      this.dialogRef.close(res);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.textsFormGroup.get('autoAllTrans')!.value;
    for (const text of this.textsArrayControl.controls) {
      text.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.textsArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const text of this.textsArrayControl.controls) {
      if (!text.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.textsFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
